/** Registered postal address shown on public marketing pages (e.g. landing, pricing). */
export const BUSINESS_ADDRESS = '526/368 Sussex St, Sydney NSW 2000';
